import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TaskAltIcon from '@mui/icons-material/TaskAltOutlined';
import Divider from '@mui/material/Divider';
import {getClassStatus} from "../../../../utils/generalUtils";

type Props = {
  open: boolean,
  handleClose: any,
  ticketNumber: string,
  plateNumber: string,
  status: string
}

export default (props: Props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      className="ticket-form-succes-dialog"
    >
      <Box>
        <Box sx={{margin: '0 9%'}}>
          <Box sx={{display: 'flex', margin: '32px 0 0'}}>
            <TaskAltIcon className="ticket-form-succes-dialog-icon" sx={{marginRight: '12px'}}/>
            <Box className="ticket-form-succes-dialog-title"><Trans i18nKey={`screens.createMaintenance.successDialogTitle`}></Trans></Box>
          </Box>
          <Box className="ticket-form-succes-dialog-success-text" sx={{marginTop: '18px'}}>
            <Trans i18nKey={`screens.createMaintenance.successDialogTicketPreffix`}></Trans>
            {` ${props.ticketNumber}`}
          </Box>
          <Box className="ticket-form-succes-dialog-text" sx={{marginTop: '18px'}}><Trans i18nKey={`screens.createMaintenance.successDialogText1`}></Trans></Box>
          <Box className="ticket-form-succes-dialog-text" sx={{marginTop: '18px'}}>
            <Trans i18nKey={`screens.createMaintenance.successDialogVehiclePreffix`}></Trans>
            {` ${props.plateNumber}`}
          </Box>
          <Box sx={{margin: '18px 0'}}>
            <span className={`ticket-form-succes-dialog-status ${getClassStatus(props.status)}`} ><Trans i18nKey={`models.ticketStatus.labels.${props.status}`} /></span>
          </Box>
        </Box>
        <Divider/>
        <Box sx={{display: 'flex', justifyContent: 'space-around', margin: '12px 9%'}}>
          <Button onClick={props.handleClose} className="ticket-form-succes-dialog-success-button">
              <Trans i18nKey={`screens.createMaintenance.successDialogAcceptButton`}></Trans>
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}